var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1732739001331,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 11862,
    width: 48,
    height: 48,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 691.2c110.9 0 201.6-90.7 201.6-201.6v-224C713.6 154.7 622.9 64 512 64s-201.6 90.7-201.6 201.6v224c0 110.9 90.7 201.6 201.6 201.6z m-156.8-224h89.6c12.3 0 22.4-10.1 22.4-22.4 0-12.3-10.1-22.4-22.4-22.4h-89.6v-44.8h89.6c12.3 0 22.4-10.1 22.4-22.4 0-12.3-10.1-22.4-22.4-22.4h-89.6V288h89.6c12.3 0 22.4-10.1 22.4-22.4s-10.1-22.4-22.4-22.4H357c10.9-75.9 76.2-134.4 155-134.4 86.5 0 156.8 70.3 156.8 156.8v224c0 86.5-70.3 156.8-156.8 156.8s-156.8-70.3-156.8-156.8v-22.4z",
    "p-id": 11863
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M869.6 491.3c0.9-13-9.2-24.1-22.2-24.1h-0.4c-12 0-21.4 9.5-22.2 21.4-11 163-147.2 292.2-312.9 292.2S210.1 651.6 199 488.6c-0.8-11.9-10.2-21.4-22.2-21.4h-0.4c-13 0-23 11.2-22.2 24.1 12 178.5 156.4 322 335.2 333.2v90.7H400c-12.3 0-22.4 10.1-22.4 22.4 0 12.3 10.1 22.4 22.4 22.4h224c12.3 0 22.4-10.1 22.4-22.4 0-12.3-10.1-22.4-22.4-22.4h-89.6v-90.7c178.8-11.2 323.2-154.6 335.2-333.2z",
    "p-id": 11864
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.bdb8aca6120a4364a8865b321baa4540.svg";
export { ForwardRef as ReactComponent };